import React from 'react';

import { Badge, BadgeProps } from 'embeds/components';

import { useCurrentUser } from '@lib/hooks';

import { useChatActivityCountUnread } from './hooks/useChatActivityCountUnread';

export interface BadgeChatActivityUnreadProps extends Omit<BadgeProps, 'classes'> {}

const BadgeChatActivityUnread = ({ ...rest }: BadgeChatActivityUnreadProps) => {
  const currentUser = useCurrentUser();
  const { data: chatActivityCountUnread, isLoading } = useChatActivityCountUnread({
    limit: 100,
    assignee: currentUser?.id,
  });

  return <Badge badgeContent={!isLoading && chatActivityCountUnread} {...rest} />;
};

export default BadgeChatActivityUnread;
